import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const TARGET = new Date("2026-09-26T10:30:00+02:00").getTime();

const pad = (n) => String(n).padStart(2, "0");

export default function Countdown({ revealed }) {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const i = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(i);
  }, []);

  const diff = Math.max(0, TARGET - now);
  const units = [
    ["Days", Math.floor(diff / 86400000)],
    ["Hours", Math.floor(diff / 3600000) % 24],
    ["Minutes", Math.floor(diff / 60000) % 60],
    ["Seconds", Math.floor(diff / 1000) % 60],
  ];

  return (
    <motion.div
      data-testid="countdown-timer"
      initial={{ opacity: 0, y: 24 }}
      animate={revealed ? { opacity: 1, y: 0 } : {}}
      transition={{ delay: 1.15, duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
      className="mt-10"
    >
      <p className="mb-4 text-[10px] uppercase tracking-[0.35em] text-[#5A3A5A]">
        Counting down to the celebration
      </p>
      <div className="flex items-start justify-center">
        {units.map(([label, value], i) => (
          <div key={label} className="flex items-start">
            {i > 0 && (
              <span className="mx-3 mt-3 h-8 w-px bg-[#C5A059]/50 sm:mx-5" />
            )}
            <div className="flex flex-col items-center">
              <span className="font-serif-lux text-3xl font-medium tabular-nums text-[#4A3B32] sm:text-4xl">
                {pad(value)}
              </span>
              <span className="mt-1 text-[9px] uppercase tracking-[0.25em] text-[#8C6A53]">
                {label}
              </span>
            </div>
          </div>
        ))}
      </div>
    </motion.div>
  );
}
